import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BoPropertyInlineComponent, DisplayValuePipe } from './bo-property-inline.component';
import { MoneyPipe, PipeModule } from '../../../pipes';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    PipeModule,
  ],
  declarations: [
    BoPropertyInlineComponent,
    DisplayValuePipe,
  ],
  exports: [BoPropertyInlineComponent]
})
export class BoPropertyInlineModule { }
